// src/types/enums.ts
var CONTACT_TYPE_LABELS = {
  lead: "Lead",
  client: "Klient",
  partner: "Partner",
  supplier: "Dodavatel",
  referral: "Doporu\u010Den\xED",
  other: "Ostatn\xED"
};
var CONTACT_SCOPE_LABELS = {
  b2b: "B2B",
  b2c: "B2C"
};
var ROLE_HIERARCHY = {
  owner: 5,
  admin: 4,
  leader: 3,
  agent: 2,
  assistant: 1
};
var LEAD_TYPE_LABELS = {
  sale: "Prodej",
  purchase: "N\xE1kup",
  rent: "Pron\xE1jem",
  hypo: "Hypot\xE9ka",
  invest: "Investice",
  pm: "Spr\xE1va nemovitost\xED",
  other: "Ostatn\xED"
};
var LEAD_STATUS_LABELS = {
  open: "Otev\u0159en\xFD",
  won: "Vyhran\xFD",
  lost: "Prohran\xFD",
  archived: "Archivovan\xFD",
  spam: "Spam"
};
var ACTIVITY_TYPE_LABELS = {
  call: "Hovor",
  email: "E-mail",
  meeting: "Sch\u016Fzka",
  note: "Pozn\xE1mka",
  task: "\xDAkol",
  system: "Syst\xE9m"
};
var MEMBERSHIP_ROLE_LABELS = {
  owner: "Vlastn\xEDk",
  admin: "Administr\xE1tor",
  leader: "Vedouc\xED",
  agent: "Makl\xE9\u0159",
  assistant: "Asistent"
};

// src/utils/constants.ts
var API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    REFRESH: "/auth/refresh",
    ME: "/auth/me"
  },
  // Tenants
  TENANTS: {
    BASE: "/tenants",
    ME: "/tenants/me",
    BY_ID: (id) => `/tenants/${id}`,
    MEMBERS: (id) => `/tenants/${id}/members`,
    INVITE: (id) => `/tenants/${id}/members/invite`
  },
  // Projects
  PROJECTS: {
    BASE: "/projects",
    BY_ID: (id) => `/projects/${id}`,
    DOMAINS: (id) => `/projects/${id}/domains`,
    DOMAIN_BY_ID: (projectId, domainId) => `/projects/${projectId}/domains/${domainId}`
  },
  // Pipelines
  PIPELINES: {
    BASE: "/pipelines",
    BY_ID: (id) => `/pipelines/${id}`,
    STAGES: (id) => `/pipelines/${id}/stages`,
    STAGE_BY_ID: (pipelineId, stageId) => `/pipelines/${pipelineId}/stages/${stageId}`,
    REORDER: (id) => `/pipelines/${id}/stages/reorder`
  },
  // Leads
  LEADS: {
    BASE: "/leads",
    BY_ID: (id) => `/leads/${id}`,
    CHANGE_STAGE: (id) => `/leads/${id}/change-stage`,
    ASSIGN: (id) => `/leads/${id}/assign`,
    ACTIVITIES: (id) => `/leads/${id}/activities`,
    SEND_EMAIL: (id) => `/leads/${id}/send-email`
  },
  // Contacts
  CONTACTS: {
    BASE: "/contacts",
    BY_ID: (id) => `/contacts/${id}`
  },
  // Activities
  ACTIVITIES: {
    BASE: "/activities",
    BY_ID: (id) => `/activities/${id}`
  },
  // Forms
  FORMS: {
    BASE: "/forms",
    BY_ID: (id) => `/forms/${id}`
  },
  // Public Forms (widget)
  PUBLIC_FORMS: {
    CONFIG: (code) => `/public/forms/${code}/config`,
    SUBMIT: (code) => `/public/forms/${code}/submit`
  },
  // Email Templates
  EMAIL_TEMPLATES: {
    BASE: "/email-templates",
    BY_ID: (id) => `/email-templates/${id}`
  },
  // Email Logs
  EMAIL_LOGS: {
    BASE: "/email-logs"
  },
  // Stats
  STATS: {
    OVERVIEW: "/stats/overview",
    LEADS_BY_PROJECT: "/stats/leads-by-project",
    LEADS_BY_STAGE: "/stats/leads-by-stage",
    LEADS_OVER_TIME: "/stats/leads-over-time",
    TOP_PERFORMERS: "/stats/top-performers",
    RECENT_ACTIVITY: "/stats/recent-activity"
  },
  // Notifications
  NOTIFICATIONS: {
    BASE: "/notifications",
    BY_ID: (id) => `/notifications/${id}`,
    READ: (id) => `/notifications/${id}/read`,
    READ_ALL: "/notifications/read-all"
  }
};
var PAGINATION = {
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
  DEFAULT_OFFSET: 0
};
var DATE_FORMATS = {
  DATE: "yyyy-MM-dd",
  DATETIME: "yyyy-MM-dd HH:mm:ss",
  DISPLAY_DATE: "d. M. yyyy",
  DISPLAY_DATETIME: "d. M. yyyy HH:mm",
  DISPLAY_TIME: "HH:mm"
};
var VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_REGEX: /^\+?[0-9\s-]{9,}$/,
  SLUG_REGEX: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  UUID_REGEX: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
};
var HEADERS = {
  TENANT_ID: "X-Tenant-ID",
  REQUEST_ID: "X-Request-ID",
  AUTHORIZATION: "Authorization"
};
var STORAGE_KEYS = {
  ACCESS_TOKEN: "realvisor_access_token",
  REFRESH_TOKEN: "realvisor_refresh_token",
  CURRENT_TENANT: "realvisor_current_tenant",
  THEME: "realvisor_theme",
  VIEW_PREFERENCE: "realvisor_view_preference"
};
var QUERY_KEYS = {
  TENANTS: "tenants",
  TENANT: "tenant",
  PROJECTS: "projects",
  PROJECT: "project",
  PIPELINES: "pipelines",
  PIPELINE: "pipeline",
  LEADS: "leads",
  LEAD: "lead",
  CONTACTS: "contacts",
  CONTACT: "contact",
  ACTIVITIES: "activities",
  FORMS: "forms",
  FORM: "form",
  EMAIL_TEMPLATES: "email-templates",
  EMAIL_LOGS: "email-logs",
  STATS: "stats",
  NOTIFICATIONS: "notifications",
  USER: "user"
};

// src/utils/helpers.ts
function slugify(text) {
  return text.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-").replace(/-+/g, "-");
}
function isValidEmail(email) {
  return VALIDATION.EMAIL_REGEX.test(email);
}
function isValidPhone(phone) {
  return VALIDATION.PHONE_REGEX.test(phone);
}
function isValidSlug(slug) {
  return VALIDATION.SLUG_REGEX.test(slug);
}
function isValidUUID(uuid) {
  return VALIDATION.UUID_REGEX.test(uuid);
}
function formatContactName(firstName, lastName) {
  const parts = [firstName, lastName].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : "Nezn\xE1m\xFD kontakt";
}
function formatCurrency(amount) {
  if (amount === null || amount === void 0) return "-";
  return new Intl.NumberFormat("cs-CZ", {
    style: "currency",
    currency: "CZK",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}
function formatNumber(num) {
  if (num === null || num === void 0) return "-";
  return new Intl.NumberFormat("cs-CZ").format(num);
}
function formatPercentage(value) {
  if (value === null || value === void 0) return "-";
  return `${value} %`;
}
function truncate(text, maxLength) {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}...`;
}
function getInitials(name) {
  if (!name) return "?";
  return name.split(" ").map((part) => part[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}
function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function isEmpty(value) {
  if (value === null || value === void 0) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
}
function cleanObject(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== void 0 && value !== null)
  );
}
function randomColor() {
  const colors = [
    "#3B82F6",
    // blue
    "#8B5CF6",
    // violet
    "#EC4899",
    // pink
    "#EF4444",
    // red
    "#F59E0B",
    // amber
    "#10B981",
    // emerald
    "#06B6D4",
    // cyan
    "#6366F1"
    // indigo
  ];
  return colors[Math.floor(Math.random() * colors.length)] ?? "#6B7280";
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function debounce(func, wait) {
  let timeoutId = null;
  return function(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
function groupBy(array, keyFn) {
  return array.reduce(
    (result, item) => {
      const key = keyFn(item);
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    },
    {}
  );
}
function sortBy(array, keyFn, desc = false) {
  return [...array].sort((a, b) => {
    const aVal = keyFn(a);
    const bVal = keyFn(b);
    if (aVal < bVal) return desc ? 1 : -1;
    if (aVal > bVal) return desc ? -1 : 1;
    return 0;
  });
}

// src/permissions.ts
var ALL = "*";
var ROLE_PERMISSIONS = {
  // ---- Stávající CRM role ----
  owner: [ALL],
  admin: [ALL],
  leader: [
    "softphone",
    "contacts:own",
    "contacts:all",
    "leads:own",
    "leads:all",
    "leads:assign",
    "activities:own",
    "activities:all",
    "call_scripts:read",
    "call_scripts:write",
    "call_stats",
    "pipeline:read",
    "pipeline:write",
    "sip:config",
    "forms",
    "email",
    "properties",
    "discovery",
    "mortgages",
    "guides",
    "projects:manage",
    "projects:read",
    "users:manage"
  ],
  agent: [
    "softphone",
    "contacts:own",
    "contacts:all",
    "leads:own",
    "leads:all",
    "activities:own",
    "activities:all",
    "call_scripts:read",
    "call_stats",
    "pipeline:read",
    "pipeline:write",
    "forms",
    "email",
    "properties",
    "discovery",
    "mortgages",
    "guides",
    "projects:read"
  ],
  assistant: [
    "contacts:all",
    "leads:all",
    "activities:all",
    "pipeline:read",
    "properties",
    "guides",
    "projects:read"
  ],
  // ---- Call centrum role ----
  cc_operator: [
    "softphone",
    "contacts:own",
    "leads:own",
    "activities:own",
    "call_scripts:read",
    "campaigns:read",
    "campaigns:operate"
  ],
  cc_supervisor: [
    "softphone",
    "contacts:own",
    "contacts:all",
    "leads:own",
    "leads:all",
    "leads:assign",
    "activities:own",
    "activities:all",
    "call_scripts:read",
    "call_scripts:write",
    "call_stats",
    "campaigns:read",
    "campaigns:manage",
    "campaigns:operate"
  ],
  cc_manager: [
    "softphone",
    "contacts:own",
    "contacts:all",
    "leads:own",
    "leads:all",
    "leads:assign",
    "activities:own",
    "activities:all",
    "call_scripts:read",
    "call_scripts:write",
    "call_stats",
    "pipeline:read",
    "sip:config",
    "cc_users:manage",
    "campaigns:read",
    "campaigns:manage",
    "campaigns:operate"
  ]
};
function hasPermission(role, permission) {
  const perms = ROLE_PERMISSIONS[role];
  if (!perms) return false;
  if (perms.includes(ALL)) return true;
  return perms.includes(permission);
}
function isCallCenterRole(role) {
  return role.startsWith("cc_");
}
function getPermissions(role) {
  const perms = ROLE_PERMISSIONS[role];
  if (!perms) return [];
  if (perms.includes(ALL)) {
    return Object.values(ROLE_PERMISSIONS).flat().filter((p) => p !== ALL).filter((v, i, a) => a.indexOf(v) === i);
  }
  return perms;
}

// src/valuo/form-variants.ts
var VALUO_FORM_VARIANTS = {
  // Kompletní - všechna pole, prodej i pronájem
  complete: {
    propertyTypes: ["flat", "house", "land"],
    kindTypes: ["sale", "lease"],
    fields: {
      kind: { visible: true, default: "sale" },
      propertyType: { visible: true },
      address: { visible: true, required: true },
      floorArea: { visible: true, required: true },
      lotArea: { visible: true, required: true },
      rating: { visible: true, required: true },
      localType: { visible: true },
      ownership: { visible: true },
      houseType: { visible: true },
      landType: { visible: true, required: true },
      construction: { visible: true },
      floor: { visible: true },
      totalFloors: { visible: true },
      elevator: { visible: true },
      energyPerformance: { visible: true },
      equipment: { visible: true },
      easyAccess: { visible: true },
      loggiaArea: { visible: true },
      balconyArea: { visible: true },
      terraceArea: { visible: true },
      cellarArea: { visible: true },
      gardenArea: { visible: true },
      rooms: { visible: true },
      bathrooms: { visible: true },
      garages: { visible: true },
      parkingSpaces: { visible: true }
    }
  },
  // Pouze prodej - jen povinná pole
  sale_only: {
    propertyTypes: ["flat", "house", "land"],
    kindTypes: ["sale"],
    fields: {
      kind: { visible: false, default: "sale" },
      propertyType: { visible: true },
      address: { visible: true, required: true },
      floorArea: { visible: true, required: true },
      lotArea: { visible: true, required: true },
      rating: { visible: true, required: true },
      localType: { visible: true, required: true },
      houseType: { visible: true, required: true },
      landType: { visible: true, required: true },
      // Ostatní pole skrytá
      ownership: { visible: false },
      construction: { visible: false },
      floor: { visible: false },
      totalFloors: { visible: false },
      elevator: { visible: false },
      equipment: { visible: false },
      balconyArea: { visible: false },
      cellarArea: { visible: false },
      garages: { visible: false },
      parkingSpaces: { visible: false }
    }
  },
  // Pouze pronájem - jen povinná pole.
  // `equipment` (zařízeno/nezařízeno) je u nájmu zásadní cenotvorný faktor,
  // proto je viditelné i v této jinak minimální variantě. Povinné být nesmí —
  // validace bere `false` jako prázdnou hodnotu.
  lease_only: {
    propertyTypes: ["flat", "house"],
    kindTypes: ["lease"],
    fields: {
      kind: { visible: false, default: "lease" },
      propertyType: { visible: true },
      address: { visible: true, required: true },
      floorArea: { visible: true, required: true },
      // Valuo plochu pozemku u domu vyžaduje i u pronájmu — bez ní
      // ocenění domu v této variantě vždy selhalo.
      lotArea: { visible: true, required: true },
      rating: { visible: true, required: true },
      localType: { visible: true, required: true },
      houseType: { visible: true, required: true },
      equipment: { visible: true },
      // Ostatní pole skrytá
      ownership: { visible: false },
      construction: { visible: false },
      floor: { visible: false },
      totalFloors: { visible: false },
      elevator: { visible: false },
      balconyArea: { visible: false },
      cellarArea: { visible: false },
      garages: { visible: false },
      parkingSpaces: { visible: false }
    }
  },
  // Minimální - jen základní povinná pole
  minimal: {
    propertyTypes: ["flat", "house", "land"],
    kindTypes: ["sale"],
    fields: {
      kind: { visible: false, default: "sale" },
      propertyType: { visible: true },
      address: { visible: true, required: true },
      floorArea: { visible: true, required: true },
      lotArea: { visible: true, required: true },
      rating: { visible: true, required: true },
      localType: { visible: true, required: true },
      // Dispozice pro byt
      houseType: { visible: true, required: true },
      // Typ domu
      landType: { visible: true, required: true },
      // Typ pozemku
      // Všechna ostatní pole skrytá
      ownership: { visible: false },
      construction: { visible: false },
      floor: { visible: false },
      totalFloors: { visible: false },
      elevator: { visible: false },
      equipment: { visible: false },
      balconyArea: { visible: false },
      cellarArea: { visible: false },
      garages: { visible: false },
      parkingSpaces: { visible: false }
    }
  }
};
var VALUO_REQUIRED_FIELDS = {
  flat: ["floorArea", "rating"],
  house: ["floorArea", "lotArea", "rating"],
  land: ["lotArea"]
};
var VALUO_PROPERTY_TYPES_BY_KIND = {
  sale: ["flat", "house", "land"],
  lease: ["flat", "house"]
};
function isValuoCombinationSupported(kind, propertyType) {
  const allowed = VALUO_PROPERTY_TYPES_BY_KIND[kind === "lease" ? "lease" : "sale"];
  return allowed.includes(propertyType);
}
function getMissingValuoFields(propertyType, data) {
  const required = VALUO_REQUIRED_FIELDS[propertyType] ?? [];
  return required.filter((field) => {
    const value = data[field];
    if (value === void 0 || value === null || value === "") return true;
    if (typeof value === "number") return !(value > 0);
    return false;
  });
}
var VALUO_VARIANT_LABELS = {
  complete: {
    title: "Zjist\u011Bte cenu va\u0161\xED nemovitosti",
    subtitle: "Z\xEDskejte odhad tr\u017En\xED ceny zdarma b\u011Bhem 2 minut",
    submitButton: "Zjistit cenu"
  },
  sale_only: {
    title: "Zjist\u011Bte cenu va\u0161\xED nemovitosti",
    subtitle: "Z\xEDskejte odhad tr\u017En\xED ceny zdarma b\u011Bhem 2 minut",
    submitButton: "Zjistit cenu"
  },
  lease_only: {
    title: "Zjist\u011Bte v\xFD\u0161i n\xE1jmu va\u0161\xED nemovitosti",
    subtitle: "Z\xEDskejte odhad tr\u017En\xEDho n\xE1jemn\xE9ho zdarma b\u011Bhem 2 minut",
    submitButton: "Zjistit v\xFD\u0161i n\xE1jmu"
  },
  minimal: {
    title: "Zjist\u011Bte cenu va\u0161\xED nemovitosti",
    subtitle: "Z\xEDskejte odhad tr\u017En\xED ceny zdarma b\u011Bhem 2 minut",
    submitButton: "Zjistit cenu"
  }
};
var VALUO_VARIANT_OPTIONS = [
  { value: "complete", label: "Kompletn\xED", description: "Prodej i pron\xE1jem, v\u0161echna pole" },
  { value: "sale_only", label: "Pouze prodej", description: "Bez pron\xE1jmu, jen povinn\xE1 pole" },
  { value: "lease_only", label: "Pouze pron\xE1jem", description: "Bez prodeje, jen povinn\xE1 pole" },
  { value: "minimal", label: "Minim\xE1ln\xED", description: "Jen z\xE1kladn\xED povinn\xE1 pole" }
];
function isLeaseOnlyVariant(variant) {
  const config = VALUO_FORM_VARIANTS[variant];
  return !!config && config.kindTypes.length === 1 && config.kindTypes[0] === "lease";
}
export {
  ACTIVITY_TYPE_LABELS,
  API_ENDPOINTS,
  CONTACT_SCOPE_LABELS,
  CONTACT_TYPE_LABELS,
  DATE_FORMATS,
  HEADERS,
  LEAD_STATUS_LABELS,
  LEAD_TYPE_LABELS,
  MEMBERSHIP_ROLE_LABELS,
  PAGINATION,
  QUERY_KEYS,
  ROLE_HIERARCHY,
  ROLE_PERMISSIONS,
  STORAGE_KEYS,
  VALIDATION,
  VALUO_FORM_VARIANTS,
  VALUO_PROPERTY_TYPES_BY_KIND,
  VALUO_REQUIRED_FIELDS,
  VALUO_VARIANT_LABELS,
  VALUO_VARIANT_OPTIONS,
  cleanObject,
  debounce,
  deepClone,
  delay,
  formatContactName,
  formatCurrency,
  formatNumber,
  formatPercentage,
  getInitials,
  getMissingValuoFields,
  getPermissions,
  groupBy,
  hasPermission,
  isCallCenterRole,
  isEmpty,
  isLeaseOnlyVariant,
  isValidEmail,
  isValidPhone,
  isValidSlug,
  isValidUUID,
  isValuoCombinationSupported,
  randomColor,
  slugify,
  sortBy,
  truncate
};
//# sourceMappingURL=index.mjs.map